import React from "react";
import { useSelector } from "react-redux";

import { selecetBeneficators } from "@redux";
import { AddRemoveInputs, StepperFormRow } from "@components";
import { Beneficiarie } from "./Beneficiarie";

export const ClientBeneficiaries = ({
  control,
  totalbeneficiariesAdded,
  setTotalBeneficiariesAdded,
  unregister
}) => {
  const beneficators = useSelector(selecetBeneficators);
  return (
    <StepperFormRow>
      {new Array(totalbeneficiariesAdded).fill(null).map((_, index) => (
        <Beneficiarie
          control={control}
          beneficiaryIndex={index}
          unregister={unregister}
          key={beneficators[index].value}
        />
      ))}

      <AddRemoveInputs
        totalInputsAdded={totalbeneficiariesAdded}
        maxInputsAllowed={beneficators.length}
        onAdd={() => setTotalBeneficiariesAdded(prev => prev + 1)}
        onRemove={() => {
          unregister(`clientBeneficiaries.${totalbeneficiariesAdded - 1}`);
          setTotalBeneficiariesAdded(prev => prev - 1);
        }}
      />
    </StepperFormRow>
  );
};
